import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';

import { DialogContentContainerContext } from '../DimeDialog.js';
import { cn } from '../lib/utils.js';

/**
 * The tree's popup, owned here (not the CLI-managed PopoverContent, which always portals to the
 * body) so that inside a dialog or sheet it portals into that content node: a body-level popup
 * sits outside the modal's scroll lock, which then swallows its wheel and touch scrolling.
 */
export function TreeComboboxPopoverContent({
  className,
  align = 'center',
  sideOffset = 4,
  ...props
}: Readonly<React.ComponentProps<typeof PopoverPrimitive.Content>>) {
  // Outside a dialog the context is null, and an undefined container keeps Radix's body default.
  const dialogContentEl = React.useContext(DialogContentContainerContext) ?? undefined;
  return (
    <PopoverPrimitive.Portal container={dialogContentEl}>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-50 flex w-72 origin-(--radix-popover-content-transform-origin) flex-col gap-2.5 rounded-lg bg-popover p-2.5 text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}
